import { render, staticRenderFns } from "./DestinationAddEditModal.vue?vue&type=template&id=4884cac6"
import script from "./DestinationAddEditModal.vue?vue&type=script&lang=js"
export * from "./DestinationAddEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports